import { formatCryptoPrice, formatTextEllipsis, formatPercentage } from '@/lib/format';
import { cn, genJudgingSizeColor } from '@/lib/utils';
import { IHotToken } from '@/request/token/token.response.interface';
import { useAppStore } from '@/store';
import TokenAvatar from '@/widget/TokenAvatar';
import { memo } from 'react';

interface IProps {
  token: IHotToken;
  onSelect?: (e: IHotToken) => void;
}

export default memo((props: IProps) => {
  const { token, onSelect } = props;
  const { fwClass, chainInfo } = useAppStore();

  return (
    <div className="flex justify-between" onClick={() => onSelect && onSelect(token)}>
      <div className="relative flex items-center gap-x-[8px]">
        <div className="relative">
          <TokenAvatar logo={token.logo} address={token.address} className="w-[30px] h-[30px]" />
          <img src={chainInfo.icon} className="p-[1px] rounded-full bg-[#fff] w-[13px] h-[13px] absolute right-0 bottom-0" />
        </div>
        <div>
          <div className={cn('text-[14px] text-primaryTextColor', fwClass)}>{token.symbol}</div>
          <div className="text-[12px] text-secondaryTextColor underline underline-offset-2">{formatTextEllipsis(token.address)}</div>
        </div>
      </div>
      <div className="text-right">
        <p className="text-[16px]">${formatCryptoPrice(token.price.toString())}</p>
        <p className={cn('text-[12px]', genJudgingSizeColor(token.priceChangePercent))}>
          {formatPercentage(token.priceChangePercent, { scale: true })}
        </p>
      </div>
    </div>
  );
});
